
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire86ed"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire86ed"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("4EKCH", function(module, exports) {

$parcel$export(module.exports, "clamp", function () { return $10da07838e6d507c$export$7d15b64cf5a3a4c4; });
$parcel$export(module.exports, "isMobile", function () { return $10da07838e6d507c$export$d0a8044dce8ff2fc; });
$parcel$export(module.exports, "isPhone", function () { return $10da07838e6d507c$export$3dc8fb2aae1f259d; });
$parcel$export(module.exports, "sprintScaledIntent", function () { return $10da07838e6d507c$export$37f678e26ae1e8b8; });
$parcel$export(module.exports, "SCALER", function () { return $10da07838e6d507c$export$c6ec669adaa5980d; });
$parcel$export(module.exports, "ScalingParams", function () { return $10da07838e6d507c$export$aa707847c2571374; });
const $10da07838e6d507c$export$7d15b64cf5a3a4c4 = (num, min, max)=>Math.min(Math.max(num, min), max);
const $10da07838e6d507c$export$d0a8044dce8ff2fc = ()=>/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
const $10da07838e6d507c$export$3dc8fb2aae1f259d = ()=>{
    if (typeof navigator === "undefined") return false;
    const ua = navigator.userAgent;
    if (/CrOS|iPad|Tablet|Silk/i.test(ua)) return false;
    return /iPhone|iPod|webOS|BlackBerry|IEMobile|Opera Mini/i.test(ua) || /Android.*Mobile/i.test(ua);
};
const $10da07838e6d507c$export$6786c0480bb11ee9 = 0.9;
const $10da07838e6d507c$export$84bfe54394ef8e9d = 1.6;
const $10da07838e6d507c$export$37f678e26ae1e8b8 = (vector, power)=>power >= $10da07838e6d507c$export$6786c0480bb11ee9 ? {
        x: vector.x * $10da07838e6d507c$export$84bfe54394ef8e9d,
        y: vector.y * $10da07838e6d507c$export$84bfe54394ef8e9d
    } : vector;
const $10da07838e6d507c$export$c6ec669adaa5980d = 1.3;
const $10da07838e6d507c$export$e4369cabd7e84cd9 = ()=>{
    const letters = "0123456789ABCDEF".split("");
    let color = "0x";
    for(var i = 0; i < 6; i++)color += letters[Math.round(Math.random() * 15)];
    return color;
};
const $10da07838e6d507c$export$aa707847c2571374 = {
    scale: $10da07838e6d507c$export$c6ec669adaa5980d,
    surfaceZoom: 2.0,
    viewportX: 7,
    viewportY: 5,
    // Extra world units revealed on each edge by the mobile canvas. Kept separate from
    // viewportX/Y, which also control the camera's fixed position and map-edge clamping.
    viewportPaddingX: 0,
    viewportPaddingY: 0
};

});

parcelRegister("2FDNO", function(module, exports) {

$parcel$export(module.exports, "stageViewport", function () { return $167efe97b4119a5d$export$b0f20d83cec42115; });
$parcel$export(module.exports, "canvasLayout", function () { return $167efe97b4119a5d$export$732c3502c7f18a71; });

var $4EKCH = parcelRequire("4EKCH");
const $167efe97b4119a5d$export$b0f20d83cec42115 = ()=>{
    const inset = (0, $4EKCH.ScalingParams).viewportPaddingX * (0, $4EKCH.ScalingParams).surfaceZoom;
    const insetY = (0, $4EKCH.ScalingParams).viewportPaddingY * (0, $4EKCH.ScalingParams).surfaceZoom;
    return {
        left: -inset,
        right: 800 + inset,
        width: 800 + inset * 2,
        inset: inset,
        top: -insetY,
        bottom: 600 / (0, $4EKCH.SCALER) + insetY,
        height: 600 / (0, $4EKCH.SCALER) + insetY * 2,
        insetY: insetY
    };
};
const $167efe97b4119a5d$var$VIRTUAL_W = 800;
const $167efe97b4119a5d$var$VIRTUAL_H = 600;
const $167efe97b4119a5d$var$DISPLAY_RATIO = $167efe97b4119a5d$var$VIRTUAL_W / ($167efe97b4119a5d$var$VIRTUAL_H / (0, $4EKCH.SCALER));
const $167efe97b4119a5d$var$MAX_BUFFER_PIXELS = 5000000;
const $167efe97b4119a5d$export$732c3502c7f18a71 = (width, height, dpr, mobile)=>{
    const wide = width / height >= $167efe97b4119a5d$var$DISPLAY_RATIO;
    const fillWidth = mobile && wide;
    const cssWidth = wide && !fillWidth ? height * $167efe97b4119a5d$var$DISPLAY_RATIO : width;
    const cssHeight = mobile || wide ? height : width / $167efe97b4119a5d$var$DISPLAY_RATIO;
    const virtualWidth = fillWidth ? width / height * ($167efe97b4119a5d$var$VIRTUAL_H / (0, $4EKCH.SCALER)) : $167efe97b4119a5d$var$VIRTUAL_W;
    const virtualHeight = mobile && !wide ? height / width * $167efe97b4119a5d$var$VIRTUAL_W * (0, $4EKCH.SCALER) : $167efe97b4119a5d$var$VIRTUAL_H;
    const stageX = (virtualWidth - $167efe97b4119a5d$var$VIRTUAL_W) / 2;
    const stageY = (virtualHeight - $167efe97b4119a5d$var$VIRTUAL_H) / 2;
    const maxResolution = Math.sqrt($167efe97b4119a5d$var$MAX_BUFFER_PIXELS / (virtualWidth * virtualHeight));
    return {
        cssWidth: cssWidth,
        cssHeight: cssHeight,
        virtualWidth: virtualWidth,
        virtualHeight: virtualHeight,
        stageX: stageX,
        stageY: stageY,
        resolution: Math.max(1, Math.min(cssWidth * dpr / virtualWidth, maxResolution))
    };
};

});

parcelRegister("3ZM90", function(module, exports) {

$parcel$export(module.exports, "ART_PX", function () { return $4a4a624f131f1e02$export$6e83f70f9f18ceb3; });
$parcel$export(module.exports, "rgb", function () { return $4a4a624f131f1e02$export$8972dc0e6ad9238f; });
$parcel$export(module.exports, "hexOf", function () { return $4a4a624f131f1e02$export$b45359e03a2958dd; });
$parcel$export(module.exports, "mix", function () { return $4a4a624f131f1e02$export$2c9e8a9632a706b2; });
$parcel$export(module.exports, "PixelBuffer", function () { return $4a4a624f131f1e02$export$3089c1a1983f0ff8; });
$parcel$export(module.exports, "fillPolygon", function () { return $4a4a624f131f1e02$export$ab20bb8f151829de; });
$parcel$export(module.exports, "drawLine", function () { return $4a4a624f131f1e02$export$819db45aec5fcbe5; });
$parcel$export(module.exports, "drawPolyline", function () { return $4a4a624f131f1e02$export$67e405e4ae7aaff9; });
$parcel$export(module.exports, "bayer", function () { return $4a4a624f131f1e02$export$ae9a7a60c842ba41; });
$parcel$export(module.exports, "hash01", function () { return $4a4a624f131f1e02$export$e943eb37acf7ab8e; });
$parcel$export(module.exports, "crossFade", function () { return $4a4a624f131f1e02$export$a006768066e296b5; });
/**
 * A tiny software rasterizer for the login screen's pixel art: a buffer of packed colours, polygons
 * and lines filled on whole pixels, and an ordered-dither matrix.
 *
 * No canvas and no pixi, so the art can be painted -- and asserted -- in a unit test, and rendered
 * to a PNG outside the browser. The scene hands the finished buffer to a canvas with putImageData.
 */ const $4a4a624f131f1e02$export$6e83f70f9f18ceb3 = 2;
const $4a4a624f131f1e02$export$8972dc0e6ad9238f = (hex, alpha = 255)=>((alpha & 0xff) << 24 | (hex & 0xff) << 16 | hex & 0xff00 | hex >>> 16 & 0xff) >>> 0;
const $4a4a624f131f1e02$export$d1ede7371489c7ed = (c)=>c >>> 24;
const $4a4a624f131f1e02$export$b45359e03a2958dd = (c)=>(c & 0xff) << 16 | c & 0xff00 | c >>> 16 & 0xff;
const $4a4a624f131f1e02$export$2c9e8a9632a706b2 = (a, b, t)=>{
    if (t <= 0) return a;
    if (t >= 1) return (a & 0xff000000 | b & 0x00ffffff) >>> 0;
    const r = (a & 0xff) + ((b & 0xff) - (a & 0xff)) * t;
    const g = (a >>> 8 & 0xff) + ((b >>> 8 & 0xff) - (a >>> 8 & 0xff)) * t;
    const bl = (a >>> 16 & 0xff) + ((b >>> 16 & 0xff) - (a >>> 16 & 0xff)) * t;
    return (a & 0xff000000 | Math.round(bl) << 16 | Math.round(g) << 8 | Math.round(r)) >>> 0;
};
class $4a4a624f131f1e02$export$3089c1a1983f0ff8 {
    constructor(w, h, x0 = 0, y0 = 0){
        this.w = w;
        this.h = h;
        this.x0 = x0;
        this.y0 = y0;
        this./** The index of (x, y), or -1 outside the buffer. */ index = (x, y)=>{
            const i = x - this.x0;
            const j = y - this.y0;
            return i < 0 || j < 0 || i >= this.w || j >= this.h ? -1 : j * this.w + i;
        };
        this.get = (x, y)=>{
            const i = this.index(x, y);
            return i < 0 ? 0 : this.data[i];
        };
        this.set = (x, y, c)=>{
            const i = this.index(x, y);
            if (i >= 0) this.data[i] = c;
        };
        this./** Lay `c` over what is there at `alpha` (0..1), the way a translucent sprite would. */ blend = (x, y, c, alpha)=>{
            const i = this.index(x, y);
            if (i < 0 || alpha <= 0) return;
            const under = this.data[i];
            const ua = $4a4a624f131f1e02$export$d1ede7371489c7ed(under) / 255;
            if (ua <= 0) {
                this.data[i] = (Math.round(alpha * 255) << 24 | c & 0x00ffffff) >>> 0;
                return;
            }
            const out = ua + alpha * (1 - ua);
            const mixed = $4a4a624f131f1e02$export$2c9e8a9632a706b2(under, c, alpha / out);
            this.data[i] = (Math.round(out * 255) << 24 | mixed & 0x00ffffff) >>> 0;
        };
        this.clear = ()=>this.data.fill(0);
        this./** The smallest buffer holding every painted pixel, in the same coordinates (undefined when empty). */ cropped = ()=>{
            let x0 = Infinity, y0 = Infinity, x1 = -Infinity, y1 = -Infinity;
            for(let j = 0; j < this.h; j++){
                for(let i = 0; i < this.w; i++)if (this.data[j * this.w + i]) {
                    if (i < x0) x0 = i;
                    if (i > x1) x1 = i;
                    if (j < y0) y0 = j;
                    if (j > y1) y1 = j;
                }
            }
            if (x1 < 0) return undefined;
            const out = new $4a4a624f131f1e02$export$3089c1a1983f0ff8(x1 - x0 + 1, y1 - y0 + 1, this.x0 + x0, this.y0 + y0);
            for(let j = y0; j <= y1; j++)out.data.set(this.data.subarray(j * this.w + x0, j * this.w + x1 + 1), (j - y0) * out.w);
            return out;
        };
        this./** Copy every opaque-ish pixel of `src` in, offset by (dx, dy). */ draw = (src, dx = 0, dy = 0)=>{
            for(let j = 0; j < src.h; j++)for(let i = 0; i < src.w; i++){
                const c = src.data[j * src.w + i];
                if (c) this.set(src.x0 + i + dx, src.y0 + j + dy, c);
            }
        };
        this./**
     * Into an RGBA byte array `w * h * 4` long, mirrored left to right when asked. That is the scene
     * flipping the authored drawing onto the other side of the screen at upload time.
     */ writeRgba = (out, mirrored)=>{
            if (!mirrored) {
                out.set(this.data);
                return;
            }
            const w = this.w;
            for(let j = 0; j < this.h; j++){
                const row = j * w;
                for(let i = 0; i < w; i++)out[row + i] = this.data[row + w - 1 - i];
            }
        };
        this.data = new Uint32Array(Math.max(1, w * h));
    }
}
const $4a4a624f131f1e02$export$ab20bb8f151829de = (pts, plot)=>{
    if (pts.length < 3) return;
    let minY = Infinity;
    let maxY = -Infinity;
    for (const p of pts){
        if (p[1] < minY) minY = p[1];
        if (p[1] > maxY) maxY = p[1];
    }
    const xs = [];
    for(let y = Math.ceil(minY - 0.5); y <= Math.floor(maxY - 0.5); y++){
        const yc = y + 0.5;
        xs.length = 0;
        for(let i = 0, j = pts.length - 1; i < pts.length; j = i++){
            const yi = pts[i][1];
            const yj = pts[j][1];
            if (yi > yc !== yj > yc) xs.push(pts[i][0] + (yc - yi) * (pts[j][0] - pts[i][0]) / (yj - yi));
        }
        xs.sort((a, b)=>a - b);
        for(let k = 0; k + 1 < xs.length; k += 2)for(let x = Math.ceil(xs[k] - 0.5); x <= Math.floor(xs[k + 1] - 0.5); x++)plot(x, y);
    }
};
const $4a4a624f131f1e02$export$819db45aec5fcbe5 = (x0, y0, x1, y1, plot)=>{
    let x = Math.floor(x0);
    let y = Math.floor(y0);
    const xe = Math.floor(x1);
    const ye = Math.floor(y1);
    const dx = Math.abs(xe - x);
    const dy = -Math.abs(ye - y);
    const sx = x < xe ? 1 : -1;
    const sy = y < ye ? 1 : -1;
    let err = dx + dy;
    for(let guard = 0; guard < 4096; guard++){
        plot(x, y);
        if (x === xe && y === ye) return;
        const e2 = 2 * err;
        if (e2 >= dy) {
            err += dy;
            x += sx;
        }
        if (e2 <= dx) {
            err += dx;
            y += sy;
        }
    }
};
const $4a4a624f131f1e02$export$67e405e4ae7aaff9 = (pts, plot)=>{
    let lastX = NaN;
    let lastY = NaN;
    const once = (x, y)=>{
        if (x !== lastX || y !== lastY) {
            lastX = x;
            lastY = y;
            plot(x, y);
        }
    };
    for(let i = 1; i < pts.length; i++)$4a4a624f131f1e02$export$819db45aec5fcbe5(pts[i - 1][0], pts[i - 1][1], pts[i][0], pts[i][1], once);
};
/** The 8x8 Bayer matrix: the classic ordered dither, so a dissolve or a gradient never crawls. */ const $4a4a624f131f1e02$var$BAYER8 = [
    0,
    32,
    8,
    40,
    2,
    34,
    10,
    42,
    48,
    16,
    56,
    24,
    50,
    18,
    58,
    26,
    12,
    44,
    4,
    36,
    14,
    46,
    6,
    38,
    60,
    28,
    52,
    20,
    62,
    30,
    54,
    22,
    3,
    35,
    11,
    43,
    1,
    33,
    9,
    41,
    51,
    19,
    59,
    27,
    49,
    17,
    57,
    25,
    15,
    47,
    7,
    39,
    13,
    45,
    5,
    37,
    63,
    31,
    55,
    23,
    61,
    29,
    53,
    21
];
const $4a4a624f131f1e02$export$ae9a7a60c842ba41 = (x, y)=>$4a4a624f131f1e02$var$BAYER8[(y & 7) * 8 + (x & 7)] / 64;
const $4a4a624f131f1e02$export$e943eb37acf7ab8e = (n)=>{
    let h = Math.imul(n ^ 0x9e3779b9, 0x85ebca6b);
    h ^= h >>> 13;
    h = Math.imul(h, 0xc2b2ae35);
    h ^= h >>> 16;
    return (h >>> 0) / 4294967296;
};
const $4a4a624f131f1e02$export$a006768066e296b5 = (out, a, b, w)=>{
    const n = out.data.length;
    for(let i = 0; i < n; i++){
        const ca = a.data[i];
        const cb = b.data[i];
        if (!ca && !cb) continue;
        const x = out.x0 + i % out.w;
        const y = out.y0 + Math.floor(i / out.w);
        if (ca && cb) {
            const blended = $4a4a624f131f1e02$export$2c9e8a9632a706b2(ca, cb, w);
            const alpha = ($4a4a624f131f1e02$export$d1ede7371489c7ed(ca) + ($4a4a624f131f1e02$export$d1ede7371489c7ed(cb) - $4a4a624f131f1e02$export$d1ede7371489c7ed(ca)) * w) / 255;
            if (alpha >= 1) out.data[i] = blended;
            else out.blend(x, y, blended, alpha);
        } else if (ca) out.blend(x, y, ca, (1 - w) * $4a4a624f131f1e02$export$d1ede7371489c7ed(ca) / 255);
        else out.blend(x, y, cb, w * $4a4a624f131f1e02$export$d1ede7371489c7ed(cb) / 255);
    }
};

});

parcelRegister("eQBYH", function(module, exports) {

$parcel$export(module.exports, "LOADING_TITLE_H", function () { return $abd1681cef6d3ae8$export$5647566d7d518e24; });
$parcel$export(module.exports, "TITLE_H", function () { return $abd1681cef6d3ae8$export$cffa5a4910e0caca; });
$parcel$export(module.exports, "trackingFor", function () { return $abd1681cef6d3ae8$export$7ebbf45ec89db2b3; });
$parcel$export(module.exports, "TITLE_STYLE", function () { return $abd1681cef6d3ae8$export$e9ee39f18bc7d5b9; });
$parcel$export(module.exports, "titleLetter", function () { return $abd1681cef6d3ae8$export$9255c978ab6b692d; });
$parcel$export(module.exports, "growBuffers", function () { return $abd1681cef6d3ae8$export$eb547097e5efa66d; });
$parcel$export(module.exports, "paintGrowingLetter", function () { return $abd1681cef6d3ae8$export$b824597d3fc44e42; });

var $3ZM90 = parcelRequire("3ZM90");

var $7M6bL = parcelRequire("7M6bL");
const $abd1681cef6d3ae8$export$5647566d7d518e24 = 12;
const $abd1681cef6d3ae8$export$cffa5a4910e0caca = 20;
const $abd1681cef6d3ae8$export$7ebbf45ec89db2b3 = (h)=>Math.round(h * 0.55);
const $abd1681cef6d3ae8$export$6041d920c15e67e = (char, h)=>{
    const rows = (0, $7M6bL.GLYPHS)[h]?.[char];
    if (!rows) throw new Error(`No pixel glyph for "${char}" at x-height ${h}`);
    return rows;
};
const $abd1681cef6d3ae8$export$e9ee39f18bc7d5b9 = typeof location !== "undefined" && /[?&]title=crisp\b/.test(location.search) ? "crisp" : "soft";
/** Cream at the top of the letters warming toward gold at their feet: Jost's own colour, banded. */ const $abd1681cef6d3ae8$var$FILL = [
    0xfff4e2,
    0xfcecd6,
    0xf8dfbd,
    0xf1cd9a
].map((h)=>(0, $3ZM90.rgb)(h));
/** Crisp only: the top edge of a stroke catches the light, its underside runs a step warmer. */ const $abd1681cef6d3ae8$var$LIT_EDGE = (0, $3ZM90.rgb)(0xfffbf2);
const $abd1681cef6d3ae8$var$UNDERSIDE = (0, $3ZM90.rgb)(0xe6b878);
/** Soft only: alpha by coverage. Translucent, so the letters sit as softly on any background. */ const $abd1681cef6d3ae8$var$softAlpha = (tenths)=>tenths >= 7 ? 255 : tenths >= 4 ? 170 : tenths >= 2 ? 85 : 0;
/**
 * Which pixels are ink when every pixel must be ink or empty: those at least half covered, plus any
 * a third covered that joins two separate parts of the stroke -- a light weight's thin curves would
 * otherwise break where they run between two pixels.
 */ const $abd1681cef6d3ae8$var$inkOf = (rows)=>{
    const w = rows[0].length;
    const h = rows.length;
    const cov = (x, y)=>x >= 0 && y >= 0 && x < w && y < h ? rows[y].charCodeAt(x) - 48 : 0;
    const ink = new Uint8Array(w * h);
    for(let y = 0; y < h; y++)for(let x = 0; x < w; x++)ink[y * w + x] = cov(x, y) >= 5 ? 1 : 0;
    const at = (x, y)=>x >= 0 && y >= 0 && x < w && y < h ? ink[y * w + x] : 0;
    const ring = [
        [
            0,
            -1
        ],
        [
            1,
            -1
        ],
        [
            1,
            0
        ],
        [
            1,
            1
        ],
        [
            0,
            1
        ],
        [
            -1,
            1
        ],
        [
            -1,
            0
        ],
        [
            -1,
            -1
        ]
    ];
    for(let y = 0; y < h; y++)for(let x = 0; x < w; x++){
        if (ink[y * w + x] || cov(x, y) < 3) continue;
        // Pieces of ink around the pixel: count the gaps between runs going round its 8 neighbours.
        let pieces = 0;
        for(let k = 0; k < 8; k++){
            const [ax, ay] = ring[k];
            const [bx, by] = ring[(k + 1) % 8];
            if (!at(x + ax, y + ay) && at(x + bx, y + by)) pieces++;
        }
        if (pieces >= 2) ink[y * w + x] = 1;
    }
    return ink;
};
const $abd1681cef6d3ae8$var$GLOW_PAD = 4;
const $abd1681cef6d3ae8$var$letters = new Map();
const $abd1681cef6d3ae8$export$9255c978ab6b692d = (char, h = $abd1681cef6d3ae8$export$cffa5a4910e0caca, style = $abd1681cef6d3ae8$export$e9ee39f18bc7d5b9)=>{
    const key = `${char}:${h}:${style}`;
    const cached = $abd1681cef6d3ae8$var$letters.get(key);
    if (cached) return cached;
    const rows = $abd1681cef6d3ae8$export$6041d920c15e67e(char, h);
    const w = rows[0].length;
    const ink = $abd1681cef6d3ae8$var$inkOf(rows);
    const coverage = (x, y)=>x >= 0 && y >= 0 && x < w && y < rows.length ? rows[y].charCodeAt(x) - 48 : 0;
    const inkAt = (x, y)=>x >= 0 && y >= 0 && x < w && y < rows.length && ink[y * w + x] === 1;
    /** What the glow spreads from: the ink, or (soft) everything well covered. */ const solid = (x, y)=>style === "crisp" ? inkAt(x, y) : coverage(x, y) >= 4;
    // The body, in the fill colour of its row. No outline -- the type wordmark had none, and a dark
    // rim makes every step of a curve stand out.
    const body = new (0, $3ZM90.PixelBuffer)(w, rows.length);
    for(let y = 0; y < rows.length; y++){
        const fill = $abd1681cef6d3ae8$var$FILL[Math.max(0, Math.min($abd1681cef6d3ae8$var$FILL.length - 1, Math.floor((y - 1) / h * $abd1681cef6d3ae8$var$FILL.length)))];
        for(let x = 0; x < w; x++){
            if (style === "soft") {
                const alpha = $abd1681cef6d3ae8$var$softAlpha(coverage(x, y));
                if (alpha) body.set(x, y, (0, $3ZM90.rgb)((0, $3ZM90.hexOf)(fill), alpha));
            } else if (inkAt(x, y)) body.set(x, y, !inkAt(x, y - 1) ? $abd1681cef6d3ae8$var$LIT_EDGE : !inkAt(x, y + 1) ? $abd1681cef6d3ae8$var$UNDERSIDE : fill);
        }
    }
    // The glow: distance from the glyph's solid pixels, in steps, never a smooth falloff.
    const pad = $abd1681cef6d3ae8$var$GLOW_PAD;
    const glow = new (0, $3ZM90.PixelBuffer)(w + pad * 2, rows.length + pad * 2);
    for(let y = 0; y < glow.h; y++)for(let x = 0; x < glow.w; x++){
        let d = Infinity;
        for(let j = -pad - 1; j <= pad + 1 && d > 0; j++){
            for(let i = -pad - 1; i <= pad + 1; i++)if (solid(x - pad + i, y - pad + j)) d = Math.min(d, Math.hypot(i, j));
        }
        const alpha = d <= 1.5 ? 150 : d <= 3 ? 80 : d <= pad + 0.5 ? 34 : 0;
        if (alpha) glow.set(x, y, (0, $3ZM90.rgb)(0xffffff, alpha));
    }
    const letter = {
        char: char,
        h: h,
        advance: w,
        body: body,
        glow: glow
    };
    $abd1681cef6d3ae8$var$letters.set(key, letter);
    return letter;
};
const $abd1681cef6d3ae8$export$eb547097e5efa66d = (char)=>{
    const big = $abd1681cef6d3ae8$export$9255c978ab6b692d(char, $abd1681cef6d3ae8$export$cffa5a4910e0caca);
    return {
        body: new (0, $3ZM90.PixelBuffer)(big.body.w, big.body.h),
        glow: new (0, $3ZM90.PixelBuffer)(big.glow.w, big.glow.h)
    };
};
const $abd1681cef6d3ae8$export$b824597d3fc44e42 = (char, h, body, glow)=>{
    const h0 = Math.max($abd1681cef6d3ae8$export$5647566d7d518e24, Math.min($abd1681cef6d3ae8$export$cffa5a4910e0caca, Math.floor(h)));
    const h1 = Math.min($abd1681cef6d3ae8$export$cffa5a4910e0caca, h0 + 1);
    const w = h1 === h0 ? 0 : Math.max(0, Math.min(1, h - h0));
    const place = (size, into, layer)=>{
        const art = $abd1681cef6d3ae8$export$9255c978ab6b692d(char, size)[layer];
        const out = new (0, $3ZM90.PixelBuffer)(into.w, into.h);
        const ox = Math.floor((into.w - art.w) / 2);
        const oy = Math.floor((into.h - art.h) / 2);
        out.draw(art, ox, oy);
        return {
            out: out,
            dx: ox + art.w / 2 - into.w / 2,
            dy: oy + art.h / 2 - into.h / 2
        };
    };
    const a = place(h0, body, "body");
    const b = place(h1, body, "body");
    body.clear();
    (0, $3ZM90.crossFade)(body, a.out, b.out, w);
    glow.clear();
    (0, $3ZM90.crossFade)(glow, place(h0, glow, "glow").out, place(h1, glow, "glow").out, w);
    return {
        dx: a.dx + (b.dx - a.dx) * w,
        dy: a.dy + (b.dy - a.dy) * w
    };
};

});
parcelRegister("7M6bL", function(module, exports) {

$parcel$export(module.exports, "GLYPHS", function () { return $47c8b8cec8df1611$export$d3b70d70824e9aee; });
// GENERATED by packages/tools/src/wordmark/bake.mjs from Jost (src/fonts/jost-variable.woff2). Do not edit.
//
// The wordmark's letters at every x-height it grows through, one string per pixel row, each digit how
// much of that pixel the letter covers in tenths (9 is 90% or more). Each letter is h + 2 rows: a row
// above the x-height and one below the baseline hold the round letters' overshoot.
const $47c8b8cec8df1611$export$d3b70d70824e9aee = {
    // x-height 12, Jost 400
    12: {
        s: [
            "0001320000",
            "0189999600",
            "0898679970",
            "1990003950",
            "0994000000",
            "0699720000",
            "0069998300",
            "0001599940",
            "0000006991",
            "0520000992",
            "5992001991",
            "0899879970",
            "0069999600",
            "0000220000"
        ],
        a: [
            "000013320000",
            "004899999500",
            "029986679950",
            "005200005990",
            "000000001990",
            "000245421990",
            "018999999990",
            "089832247990",
            "199100002990",
            "299000004990",
            "199400029990",
            "069976899990",
            "006999962990",
            "000022000000"
        ],
        m: [
            "010002310000232000",
            "299299996028999700",
            "299997899699789960",
            "299700069981004990",
            "299100019930000992",
            "299000009910000893",
            "299000009910000893",
            "299000009910000893",
            "299000009910000893",
            "299000009910000893",
            "299000009910000893",
            "299000009910000893",
            "299000009910000893",
            "000000000000000000"
        ],
        r: [
            "0100320",
            "9949997",
            "9998793",
            "9970010",
            "9930000",
            "9920000",
            "9920000",
            "9920000",
            "9920000",
            "9920000",
            "9920000",
            "9920000",
            "9920000",
            "0000000"
        ]
    },
    // x-height 13, Jost 388
    13: {
        s: [
            "00013320000",
            "00699998300",
            "06997799940",
            "09930007950",
            "09940000100",
            "07995000000",
            "01899961000",
            "00049999500",
            "00000389950",
            "00000006990",
            "16500002990",
            "49950006980",
            "06999899930",
            "00499999300",
            "00002220000"
        ],
        a: [
            "000002332000",
            "002799999930",
            "009997669993",
            "004500000798",
            "000000000399",
            "000001100299",
            "001799997599",
            "029997679999",
            "079700000499",
            "099300000399",
            "099300000799",
            "089800005999",
            "039997799899",
            "003999994299",
            "000022200000"
        ],
        m: [
            "0110013300000232000",
            "0992799994028999920",
            "0998987999499889990",
            "0999300199981002994",
            "0995000049920000796",
            "0992000039900000597",
            "0992000039900000597",
            "0992000039900000597",
            "0992000039900000597",
            "0992000039900000597",
            "0992000039900000597",
            "0992000039900000597",
            "0992000039900000597",
            "0992000039900000597",
            "0000000000000000000"
        ],
        r: [
            "011003310",
            "099389992",
            "099997970",
            "099800010",
            "099400000",
            "099200000",
            "099200000",
            "099200000",
            "099200000",
            "099200000",
            "099200000",
            "099200000",
            "099200000",
            "099200000",
            "000000000"
        ]
    },
    // x-height 14, Jost 375
    14: {
        s: [
            "000013320000",
            "001799998300",
            "008997799950",
            "029910017980",
            "039900000400",
            "019960000000",
            "006999510000",
            "000499996100",
            "000004899920",
            "000000039990",
            "001000002992",
            "059300001992",
            "079940005990",
            "008999899940",
            "000599999400",
            "000002320000"
        ],
        a: [
            "000013331000",
            "004999999820",
            "079997679992",
            "028300001997",
            "000000000599",
            "000000000399",
            "001467752399",
            "049999999999",
            "299721124899",
            "698000000399",
            "895000000599",
            "896000000999",
            "599300017999",
            "099987899799",
            "017999982399",
            "000122100000"
        ],
        m: [
            "0100033200000232000",
            "9934999971039999930",
            "9979989997399889991",
            "9996000599981002995",
            "9970000099910000698",
            "9940000079700000499",
            "9930000069600000399",
            "9930000069600000399",
            "9930000069600000399",
            "9930000069600000399",
            "9930000069600000399",
            "9930000069600000399",
            "9930000069600000399",
            "9930000069600000399",
            "9930000069600000399",
            "0000000000000000000"
        ],
        r: [
            "01002320",
            "99479996",
            "99998993",
            "99920020",
            "99600000",
            "99400000",
            "99300000",
            "99300000",
            "99300000",
            "99300000",
            "99300000",
            "99300000",
            "99300000",
            "99300000",
            "99300000",
            "00000000"
        ]
    },
    // x-height 15, Jost 363
    15: {
        s: [
            "000012200000",
            "004999996000",
            "049987899910",
            "089500028970",
            "099100001500",
            "099500000000",
            "059972000000",
            "006999730000",
            "000279998200",
            "000001599920",
            "000000018980",
            "010000003990",
            "496000002990",
            "399610007970",
            "049998799920",
            "003899998200",
            "000012210000"
        ],
        a: [
            "00000123200000",
            "00059999997100",
            "01999876899910",
            "00772000018970",
            "00000000003990",
            "00000000002990",
            "00000121001990",
            "00179999974990",
            "02999655699990",
            "08960000004990",
            "29910000002990",
            "39900000004990",
            "29910000008990",
            "09970000179990",
            "03999767994990",
            "00389999711990",
            "00001321000000"
        ],
        m: [
            "0000002220000002210000",
            "0992289998200499998100",
            "0994998899914998999900",
            "0999710029979600039950",
            "0998000004997000006980",
            "0994000002993000003990",
            "0992000001991000002990",
            "0992000001991000002990",
            "0992000001991000002990",
            "0992000001991000002990",
            "0992000001991000002990",
            "0992000001991000002990",
            "0992000001991000002990",
            "0992000001991000002990",
            "0992000001991000002990",
            "0992000001991000002990",
            "0000000000000000000000"
        ],
        r: [
            "0000012200",
            "0992599980",
            "0997988960",
            "0999200200",
            "0996000000",
            "0993000000",
            "0992000000",
            "0992000000",
            "0992000000",
            "0992000000",
            "0992000000",
            "0992000000",
            "0992000000",
            "0992000000",
            "0992000000",
            "0992000000",
            "0000000000"
        ]
    },
    // x-height 16, Jost 350
    16: {
        s: [
            "0000023210000",
            "0004999997100",
            "0059987899930",
            "0099400018991",
            "0299000000730",
            "0299100000000",
            "0089820000000",
            "0029997300000",
            "0001799994000",
            "0000016999810",
            "0000000049980",
            "0000000003993",
            "0040000000994",
            "0895000000993",
            "0499600006990",
            "0059998799930",
            "0003899998300",
            "0000013310000"
        ],
        a: [
            "00000023320000",
            "00037999999600",
            "00799976799980",
            "00594000004995",
            "00000000000598",
            "00000000000399",
            "00000000000299",
            "00015788752299",
            "00499999999899",
            "03996200024899",
            "08960000000299",
            "09920000000399",
            "19920000000699",
            "09940000002999",
            "06993000039999",
            "00899866898399",
            "00069999950299",
            "00000232000000"
        ],
        m: [
            "00000013200000002310000",
            "09921799995000699997100",
            "09939988999507998999800",
            "09988100079959400049950",
            "09990000019994000006980",
            "09950000007990000003990",
            "09920000006970000002990",
            "09920000006960000002990",
            "09920000006960000002990",
            "09920000006960000002990",
            "09920000006960000002990",
            "09920000006960000002990",
            "09920000006960000002990",
            "09920000006960000002990",
            "09920000006960000002990",
            "09920000006960000002990",
            "09920000006960000002990",
            "00000000000000000000000"
        ],
        r: [
            "0000003200",
            "0992499992",
            "0996988990",
            "0999300120",
            "0996000000",
            "0993000000",
            "0992000000",
            "0992000000",
            "0992000000",
            "0992000000",
            "0992000000",
            "0992000000",
            "0992000000",
            "0992000000",
            "0992000000",
            "0992000000",
            "0992000000",
            "0000000000"
        ]
    },
    // x-height 17, Jost 338
    17: {
        s: [
            "0000133200000",
            "0028999994000",
            "0399977999700",
            "0896000049960",
            "0991000003930",
            "0992000000000",
            "0897000000000",
            "0399940000000",
            "0039999620000",
            "0000599996100",
            "0000003799910",
            "0000000039970",
            "0000000004990",
            "1710000002991",
            "7980000003990",
            "2998200018960",
            "0399987899810",
            "0017999996100",
            "0000133200000"
        ],
        a: [
            "000001333200000",
            "000599999995000",
            "039999767999700",
            "019720000059950",
            "001000000006980",
            "000000000003990",
            "000000000002990",
            "000013443002990",
            "003899999974990",
            "059985445699990",
            "299400000005990",
            "697000000002990",
            "795000000004990",
            "796000000007990",
            "698000000039990",
            "299700000498990",
            "059997679973990",
            "003899999402990",
            "000013310000000"
        ],
        m: [
            "000000133100000013310000",
            "099306999981001699998100",
            "099379989999018998999910",
            "099793000399579300039960",
            "099920000059992000005990",
            "099700000029960000002991",
            "099400000009930000000992",
            "099300000009920000000992",
            "099300000009920000000992",
            "099300000009920000000992",
            "099300000009920000000992",
            "099300000009920000000992",
            "099300000009920000000992",
            "099300000009920000000992",
            "099300000009920000000992",
            "099300000009920000000992",
            "099300000009920000000992",
            "099300000009920000000992",
            "000000000000000000000000"
        ],
        r: [
            "00000033100",
            "09932999960",
            "09959989950",
            "09995000300",
            "09980000000",
            "09950000000",
            "09930000000",
            "09930000000",
            "09930000000",
            "09930000000",
            "09930000000",
            "09930000000",
            "09930000000",
            "09930000000",
            "09930000000",
            "09930000000",
            "09930000000",
            "09930000000",
            "00000000000"
        ]
    },
    // x-height 18, Jost 325
    18: {
        s: [
            "00000133200000",
            "00038999995000",
            "00499977999810",
            "00995000039980",
            "02990000002981",
            "03990000000200",
            "01993000000000",
            "00799400000000",
            "00189995100000",
            "00005999972000",
            "00000037999600",
            "00000000179960",
            "00000000005992",
            "00000000000994",
            "05900000000894",
            "09970000001992",
            "03997100017980",
            "00499987899920",
            "00027999997200",
            "00000133310000"
        ],
        a: [
            "0000002333200000",
            "0002799999984000",
            "0079998767999600",
            "0089510000069940",
            "0011000000007980",
            "0000000000003990",
            "0000000000002990",
            "0000000000002990",
            "0002689998622990",
            "0059998889998990",
            "0599510000148990",
            "0994000000002990",
            "3990000000003990",
            "4980000000005990",
            "3990000000008990",
            "1993000000059990",
            "0799300000696990",
            "0189986679952990",
            "0006999998302990",
            "0000023310000000"
        ],
        m: [
            "0000000332000000023310000",
            "0992059999930002899997100",
            "0992699889993039987999800",
            "0995940001899197100049950",
            "0999300000199880000006990",
            "0997000000079920000002991",
            "0994000000069900000000992",
            "0992000000059700000000992",
            "0992000000059700000000992",
            "0992000000059700000000992",
            "0992000000059700000000992",
            "0992000000059700000000992",
            "0992000000059700000000992",
            "0992000000059700000000992",
            "0992000000059700000000992",
            "0992000000059700000000992",
            "0992000000059700000000992",
            "0992000000059700000000992",
            "0992000000059700000000992",
            "0000000000000000000000000"
        ],
        r: [
            "00000033200",
            "09922899981",
            "09939978980",
            "09996000210",
            "09980000000",
            "09950000000",
            "09930000000",
            "09920000000",
            "09920000000",
            "09920000000",
            "09920000000",
            "09920000000",
            "09920000000",
            "09920000000",
            "09920000000",
            "09920000000",
            "09920000000",
            "09920000000",
            "09920000000",
            "00000000000"
        ]
    },
    // x-height 19, Jost 313
    19: {
        s: [
            "000000333100000",
            "000179999972000",
            "002999767999500",
            "008970000169940",
            "019910000006970",
            "019900000000300",
            "019930000000000",
            "007992000000000",
            "001999620000000",
            "000179998400000",
            "000002799994000",
            "000000014899700",
            "000000000059960",
            "000000000005990",
            "002000000002991",
            "079200000001991",
            "079800000004990",
            "019982000039950",
            "002999977899700",
            "000169999995000",
            "000000233200000"
        ],
        a: [
            "0000001333310000",
            "0000589999997200",
            "0049999766899940",
            "0069720000017992",
            "0003000000000996",
            "0000000000000598",
            "0000000000000399",
            "0000000000000399",
            "0000035665300399",
            "0005999999996599",
            "0079964222469999",
            "0599200000000699",
            "0994000000000399",
            "1991000000000499",
            "2991000000000799",
            "1992000000001999",
            "0896000000007999",
            "0499600000289599",
            "0069997668993399",
            "0004899999610399",
            "0000013320000000"
        ],
        m: [
            "00000002331000000023310000",
            "19910499999600004999997000",
            "19915997799970069987999800",
            "19949500005993495000059940",
            "19984000000797950000006980",
            "19980000000399800000002991",
            "19940000000199500000000992",
            "19920000000099300000000992",
            "19910000000099200000000993",
            "19910000000099200000000993",
            "19910000000099200000000993",
            "19910000000099200000000993",
            "19910000000099200000000993",
            "19910000000099200000000993",
            "19910000000099200000000993",
            "19910000000099200000000993",
            "19910000000099200000000993",
            "19910000000099200000000993",
            "19910000000099200000000993",
            "19910000000099200000000993",
            "00000000000000000000000000"
        ],
        r: [
            "00000023300",
            "09921799994",
            "09938987993",
            "09987100030",
            "09991000000",
            "09960000000",
            "09940000000",
            "09930000000",
            "09920000000",
            "09920000000",
            "09920000000",
            "09920000000",
            "09920000000",
            "09920000000",
            "09920000000",
            "09920000000",
            "09920000000",
            "09920000000",
            "09920000000",
            "09920000000",
            "00000000000"
        ]
    },
    // x-height 20, Jost 300
    20: {
        s: [
            "000001333200000",
            "000179999994000",
            "001999767999700",
            "008970000049970",
            "019900000003992",
            "029900000000430",
            "029900000000000",
            "009960000000000",
            "004997100000000",
            "000599974000000",
            "000026999951000",
            "000000158999400",
            "000000000389950",
            "000000000006992",
            "000000000000995",
            "013000000000696",
            "199100000000795",
            "079800000001993",
            "019982000017980",
            "002999876799910",
            "000169999997100",
            "000000234310000"
        ],
        a: [
            "00000023443100000",
            "00016999999972000",
            "00699986567999400",
            "01995100000179920",
            "00310000000008960",
            "00000000000004990",
            "00000000000002990",
            "00000000000001990",
            "00000012100001990",
            "00037999999621990",
            "00799976668998990",
            "06994000000048990",
            "29920000000001990",
            "59700000000002990",
            "79500000000003990",
            "79500000000006990",
            "69700000000019990",
            "39920000000088990",
            "08993000002893990",
            "01899865689921990",
            "00069999996101990",
            "00000243200000000"
        ],
        m: [
            "000000024320000000134310000",
            "199003899998100006999996000",
            "199039977899910189977999700",
            "199296000029970793000059930",
            "199750000003994910000007970",
            "199800000000999400000003990",
            "199400000000799000000001992",
            "199100000000697000000000992",
            "199000000000596000000000992",
            "199000000000596000000000992",
            "199000000000596000000000992",
            "199000000000596000000000992",
            "199000000000596000000000992",
            "199000000000596000000000992",
            "199000000000596000000000992",
            "199000000000596000000000992",
            "199000000000596000000000992",
            "199000000000596000000000992",
            "199000000000596000000000992",
            "199000000000596000000000992",
            "199000000000596000000000992",
            "000000000000000000000000000"
        ],
        r: [
            "000000243100",
            "099107999960",
            "099289779960",
            "099781000300",
            "099910000000",
            "099600000000",
            "099400000000",
            "099200000000",
            "099200000000",
            "099100000000",
            "099100000000",
            "099100000000",
            "099100000000",
            "099100000000",
            "099100000000",
            "099100000000",
            "099100000000",
            "099100000000",
            "099100000000",
            "099100000000",
            "099100000000",
            "000000000000"
        ]
    }
};

});



//# sourceMappingURL=client.35cd2b53.js.map
